import { FieldPath, UseFormReturn } from 'react-hook-form';
import { IRefinancingForm } from './types';

export const countFtvValue = (deposit: number, refinanceAmount: number | null): number | null =>
  refinanceAmount ? (refinanceAmount / (refinanceAmount + deposit)) * 100 : 0;

export const updateError = <T extends IRefinancingForm>(
  form: UseFormReturn<T>,
  field: FieldPath<T>,
  error?: string | true | null,
) => (typeof error === 'string' ? form.setError(field, { message: error }) : form.clearErrors(field));
